import { IApplicationState } from '../../types/redux';

export function getObjectId(state: IApplicationState) {
  return state.objectInfo.objectId;
}
